import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import Magnifier from '../../../components/DietAssessment/components/Magnifier';

export function getRecipeCardDetails(content) {
  const title = content.fields?.title?.replace(/recipe/i, '').trim() || 'Missing recipe card title';
  const imageUrl = content.fields?.image?.fields?.file?.url ? `https:${content.fields.image.fields.file.url}` : '';
  const imageAlt = content.fields?.image?.fields?.title || 'Recipe image';
  const description = content.fields?.description;
  return {
    title,
    Body: () => {
      const imgRef = React.useRef(null);

      return (
        <>
          <Grid
            maxWidth="1000px"
            margin="auto"
          >
            <Typography variant="h3">{title}</Typography>
          </Grid>
          <Grid
            maxWidth="1000px"
            margin="auto"
          >
            {imageUrl && (
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1000px',
                  }}
                >
                  <img
                    ref={imgRef}
                    src={imageUrl}
                    alt={imageAlt}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      display: 'block',
                    }}
                  />
                  <Magnifier
                    zoom={2.2}
                    src={imageUrl}
                    imageRef={imgRef}
                  />
                </Box>
              </Box>
            )}
            <Typography variant="h3">{description}</Typography>
          </Grid>
        </>
      );
    },
  };
}
